import React, { createRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import TopArrow from 'assets/images/icons/topArrow.svg';

import { DropdownProps } from './DropdownProps';
import StyledDropdown from './StyledDropdown';

const Dropdown: React.FC<DropdownProps> = (props) => {
  const { open } = props;

  const ref = createRef<HTMLDivElement>();

  return (
    <StyledDropdown>
      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}>
            <div className="wrapper" ref={ref}>
              <img src={TopArrow} alt="Top arrow" />
              <div className="content">{props.children}</div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </StyledDropdown>
  );
};

export default Dropdown;
